import {
  DndContext, PointerSensor, useSensor, DndContextProps,
} from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, SortableContextProps } from '@dnd-kit/sortable';
import { ReactNode } from 'react';

interface DraggableContextProps {
  items?: SortableContextProps['items'];
  dragEnd: DndContextProps['onDragEnd'];
  children: ReactNode;
}

const DraggableContext = ({ dragEnd, items = [], children }:DraggableContextProps) => {
  const sensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 10,
    },
  });

  return (
    <DndContext sensors={[sensor]} onDragEnd={dragEnd}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  );
};

export default DraggableContext;
